/**
 * Checkbox (R398). DESIGN.md §Inputs, "Check": a 20px native checkbox with the accent as
 * accent-color, beside 14px text; the whole row is the label (44px tall under 820px).
 * Without `label` it renders the bare input (pass aria-label).
 */
import React, { forwardRef } from "react";
import { cn } from "./cn";

const box =
  "tw-m-0 tw-h-5 tw-w-5 tw-flex-none tw-cursor-pointer tw-accent-text-accent disabled:tw-cursor-not-allowed focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus-ring";

export const Checkbox = forwardRef(function Checkbox(
  { label, className, labelClassName, ...props },
  ref,
) {
  const input = (
    <input
      ref={ref}
      type="checkbox"
      className={cn(box, className)}
      {...props}
    />
  );
  if (!label) return input;
  return (
    <label
      className={cn(
        "tw-flex tw-cursor-pointer tw-items-start tw-gap-3 tw-text-sm tw-text-text max-rail:tw-min-h-11 max-rail:tw-items-center",
        props.disabled && "tw-cursor-not-allowed tw-opacity-45",
        labelClassName,
      )}
    >
      {input}
      <span>{label}</span>
    </label>
  );
});
